import { Map } from "immutable";
import isDeepEqual from "stores/isDeepEqual";
import isEqualForSearch from "views/stores/isEqualForSearch";
import Widget, { widgetAttributesForComparison } from "./Widget";
import MessagesWidgetConfig from "./MessagesWidgetConfig";
const _MessagesWidget = class _MessagesWidget extends Widget {
  constructor(id, config, filter, timerange, query, streams, streamCategories, filters, description, context) {
    super(
      id,
      _MessagesWidget.type,
      config,
      filter,
      timerange,
      query,
      streams,
      streamCategories,
      filters,
      description,
      context
    );
  }
  // eslint-disable-next-line class-methods-use-this
  get isExportable() {
    return true;
  }
  static fromJSON(value) {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = value;
    return new _MessagesWidget(
      id,
      MessagesWidgetConfig.fromJSON(config),
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
  equals(other) {
    if (other instanceof _MessagesWidget) {
      return widgetAttributesForComparison.every((key) => isDeepEqual(this[key], other[key]));
    }
    return false;
  }
  get config() {
    return this._value.config;
  }
  equalsForSearch(other) {
    if (other instanceof _MessagesWidget) {
      return widgetAttributesForComparison.every((key) => isEqualForSearch(this[key], other[key]));
    }
    return false;
  }
  toBuilder() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this._value;
    return new Builder(
      Map({ id, config, filter, timerange, query, streams, stream_categories, filters, description, context })
    );
  }
  static builder() {
    return new Builder();
  }
  static isMessagesWidget(widget) {
    return widget && widget.type === _MessagesWidget.type;
  }
};
_MessagesWidget.type = "messages";
_MessagesWidget.defaultTitle = "Untitled Message Table";
let MessagesWidget = _MessagesWidget;
export {
  MessagesWidget as default
};
class Builder extends Widget.Builder {
  build() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this.value.toObject();
    return new MessagesWidget(
      id,
      config,
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
}
